var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"accordion-header",on:{"click":_vm.handleAccordionClick}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.isActive)?_c('icon',{attrs:{"name":"arrow-up"}}):_c('icon',{attrs:{"name":"arrow-down"}})],1),_c('div',{staticClass:"panel",attrs:{"id":_vm._uid}},[_c('div',{staticClass:"inner-panel"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }